import React, { useEffect } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useState } from 'react';
import '../../../../components/SplitActions/style.scss';
import { Typography, useTheme, Tab, Tabs, Box, IconButton, Stack, Accordion, AccordionSummary, DialogActions, Button } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { dialogButtonCancel } from '../../../../utils/commonStyle';
import appapi from '../../../../api/apiClient';
import { CancelToken } from 'apisauce';
import NoDataFound from '../../../../components/NoDataFound/NoDataFound';
import ActivityIndicator from '../../../../components/DataTable/ActivityIndicator';
import moment from 'moment';
import TradeHistory from './TradeHistory';
import SendQuote from './SendQuote';
import ProcessQuote from './ProcessQuote';
import DocumentViewer from '../../../../components/DocumentViewer';
import { useSelector } from 'react-redux';
import { checkPermission } from '../../../../redux/features/authSlice';
import { useTranslation } from 'react-i18next';

const screeningStatus = {
  pending: '#f8f5e8',
  accepted: '#00A63226',
  rejected: '#C220201A',
  completed: '#006DFF1A',
  expired: '#f3f4f7',
  pendingColor: '#BA9B1D',
  acceptedColor: '#00A632',
  rejectedColor: '#C22020',
  completedColor: '#006DFF',
  expiredColor: '#14285A80',
};

export default function TradeDetails({ isDrawerOpen, toggleDrawer, trade, init, navData }) {
  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  let source = CancelToken.source();
  let source2 = CancelToken.source();

  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState(false);
  const [openAcceptReject, setOpenAcceptReject] = useState(false);
  const [openProcessQuote, setOpenProcessQuote] = useState(false);
  const [type, setType] = useState('');

  const [expanded, setExpanded] = useState(false);

  const quotesPermission = useSelector((state) => checkPermission(state, 'Trade Management', 'Manage Quotes'));
  const orderPermission = useSelector((state) => checkPermission(state, 'Trade Management', 'Manage Orders'));

  const { t } = useTranslation();
  const {
    i18n: { language },
  } = useTranslation();

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    if (trade && trade?._id) {
      initApi(trade?._id);
    } else {
    }
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, [trade, navData]);

  const initApi = async (id) => {
    await getDetails(id);
  };

  const getDetails = async (id) => {
    setLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `trader/viewQuoteDetailsForTrader/${id}`,
      {},
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setDetails(data?.response);
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <Stack
      flex={1}
      className={!isDrawerOpen ? 'shrinkside flex' : 'expandside flex'}
    >
      <div className="absolute ml-[-18px]">
        <IconButton
          disabled={!Boolean(trade)}
          className="!shadow-2xl"
          sx={{ boxShadow: 'rgba(0, 0, 0, 0.5) 1px 5px 10px !important', '&:hover': { width: '40px !important', marginLeft: '-20px' } }}
          style={{
            color: '#00000',
            width: '20px',
            paddingTop: '10px',
            height: '40px',
            zIndex: 999,
            backgroundColor: '#FFFF',
            borderRadius: '10px 0px 0px 10px',
          }}
          onClick={() => {
            toggleDrawer();
          }}
        >
          <ChevronRightIcon />
        </IconButton>
      </div>
      <Stack
        flex={1}
        style={{ background: '#FFFF', border: !isDrawerOpen ? 'none' : '1px solid #14285A1A', width: !isDrawerOpen ? '0px' : '500px', borderRadius: 1 }}
        onClose={() => {
          toggleDrawer();
        }}
      >
        {isDrawerOpen ? (
          <>
            {details?.length <= 0 && !loading && <NoDataFound />}
            {loading && (
              <Stack
                flex={1}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <ActivityIndicator />
              </Stack>
            )}
            {!loading && (
              <Stack flex={1}>
                <Box
                  sx={{
                    display: 'flex',
                    borderBottom: 1,
                    border: 'none',
                    color: 'rgba(255, 255, 255, 1)',
                    borderRadius: '5px 5px 0px 0px',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Stack
                    style={{ justifyContent: 'space-between', alignItems: 'center' }}
                    direction={'row'}
                    className="px-[16px] !mt-[10px]"
                    alignItems={'center'}
                  >
                    <Typography
                      className="fw-medium ff-Roboto fs-16"
                      color={text}
                    >
                      {t('Details')}
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    className="mr-4 rounded-[16px] h-[28px] my-2 "
                    sx={{ backgroundColor: '#f3f4f7', color: theme.palette.primary.text }}
                  >
                    <Stack
                      justifyContent={'center'}
                      alignItems={'center'}
                      className="fw-regular fs-12 ff-Roboto h-[28px] px-[10px]  capitalize"
                      style={{ width: language === 'en' ? '78px' : '110px' }}
                    >
                      <Typography
                        className="fw-medium ff-Roboto fs-12 capitalize"
                        color={text}
                      >
                        {t(details?.stage)}
                      </Typography>
                    </Stack>
                    {Boolean(details?.quoteStatus) && (
                      <Stack
                        style={{ width: language === 'en' ? '78px' : '110px' }}
                        justifyContent={'center'}
                        alignItems={'center'}
                        className="fw-regular fs-12 ff-Roboto h-[28px] px-[10px] rounded-[16px] capitalize"
                        sx={{ backgroundColor: details?.quoteStatus ? screeningStatus[details?.quoteStatus] : 'transparent', color: details?.quoteStatus ? screeningStatus[`${details?.quoteStatus}Color`] : theme.palette.primary.text }}
                      >
                        {t(details?.quoteStatus)}
                      </Stack>
                    )}
                  </Stack>
                </Box>
                <Stack
                  style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                  className="!my-[10px]"
                />
                <Stack className="flex flex-col flex-1 min-h-0">
                  <Stack
                    flexGrow={1}
                    className="relative"
                  >
                    <Stack className="flex-overflow py-2">
                      <Stack>
                        <Stack
                          direction={'row'}
                          className="px-[16px] !mb-[16px] mt-[6px]"
                        >
                          <Stack flex={0.5}>
                            <Typography
                              className="fs-12 ff-Roboto fw-regular"
                              color={text}
                            >
                              {t('ID')}
                            </Typography>
                            <Typography
                              className="fs-14 ff-Roboto fw-medium capitalize"
                              color={text}
                              style={{ maxWidth: '225px' }}
                            >
                              {details.id}
                            </Typography>
                          </Stack>
                          <Stack flex={0.5}>
                            <Typography
                              className="fs-12 ff-Roboto fw-regular "
                              color={text}
                            >
                              {t('Timestamp')}
                            </Typography>
                            <Typography
                              className="fs-14 ff-Roboto fw-medium capitalize"
                              color={text}
                            >
                              {moment(details?.createdOn).format('DD-MMM-YYYY HH:mm')}
                            </Typography>
                          </Stack>
                        </Stack>
                        {details?.quoteStatus === 'completed' && (
                          <Stack
                            direction={'row'}
                            className="px-[16px] !mb-[16px]"
                          >
                            <Stack flex={0.5}>
                              <Typography
                                className="fs-12 ff-Roboto fw-regular"
                                color={text}
                              >
                                {t('Transaction ID')}
                              </Typography>
                              <Typography
                                className="fs-14 ff-Roboto fw-medium capitalize"
                                color={text}
                                style={{ maxWidth: '225px' }}
                              >
                                {details?.transactionId || 'NA'}
                              </Typography>
                            </Stack>
                            <Stack flex={0.5}>
                              <Typography
                                className="fs-12 ff-Roboto fw-regular "
                                color={text}
                              >
                                {t('Transaction date')}
                              </Typography>
                              <Typography
                                className="fs-14 ff-Roboto fw-medium capitalize"
                                color={text}
                              >
                                {details?.transactionDate ? moment(details?.transactionDate).format('DD-MMM-YYYY HH:mm') : 'NA'}
                              </Typography>
                            </Stack>
                          </Stack>
                        )}
                        <Stack
                          direction={'row'}
                          className="px-[16px] !mb-[16px]"
                        >
                          <Stack flex={0.5}>
                            <Typography
                              className="fs-12 ff-Roboto fw-regular"
                              color={text}
                            >
                              {t('Client')}
                            </Typography>
                            <Typography
                              className="fs-14 ff-Roboto fw-medium capitalize"
                              color={text}
                              style={{ maxWidth: '225px' }}
                            >
                              {details?.companyName}
                            </Typography>
                          </Stack>
                          <Stack flex={0.5}>
                            <Typography
                              className="fs-12 ff-Roboto fw-regular "
                              color={text}
                            >
                              {t('EUA')}
                            </Typography>
                            <Typography
                              className="fs-14 ff-Roboto fw-medium capitalize"
                              color={text}
                            >
                              {details?.euaRequired}
                            </Typography>
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          className="px-[16px] !mb-[16px]"
                        >
                          <Stack flex={0.5}>
                            <Typography
                              className="fs-12 ff-Roboto fw-regular !capitalize"
                              color={text}
                            >
                              {t('Display name')}
                            </Typography>
                            <Typography
                              className="fs-14 ff-Roboto fw-medium capitalize"
                              color={text}
                              style={{ maxWidth: '225px' }}
                            >
                              {details?.displayName}
                            </Typography>
                          </Stack>
                          <Stack flex={0.5}>
                            <Typography
                              className="fs-12 ff-Roboto fw-regular "
                              color={text}
                            >
                              {t('Price / EUA')}
                            </Typography>
                            <Typography
                              className="fs-14 ff-Roboto fw-medium capitalize"
                              color={text}
                            >
                              {details?.price || details?.price === 0
                                ? '€ ' +
                                  parseFloat(details?.price)?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })
                                : '-'}
                            </Typography>
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'row'}
                          className="px-[16px] !mb-[16px]"
                        >
                          <Stack flex={0.5}>
                            <Typography
                              className="fs-12 ff-Roboto fw-regular"
                              color={text}
                            >
                              {t('Type')}
                            </Typography>
                            <Typography
                              className="fs-14 ff-Roboto fw-medium capitalize"
                              color={text}
                              style={{ maxWidth: '225px' }}
                            >
                              {t(details?.priceType)}/{t(details?.tradeType)}
                            </Typography>
                          </Stack>
                          <Stack flex={0.5}>
                            <Typography
                              className="fs-12 ff-Roboto fw-regular !capitalize"
                              color={text}
                            >
                              {t('Total amount')}
                            </Typography>
                            <Typography
                              className="fs-14 ff-Roboto fw-medium capitalize"
                              color={text}
                            >
                              {(details?.totalAmount &&
                                '€ ' +
                                  parseFloat(details?.totalAmount)?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })) ||
                                'NA'}
                            </Typography>
                          </Stack>
                        </Stack>
                        {details?.stage === 'quote' && (
                          <Stack
                            direction={'row'}
                            className="px-[16px] !mb-[16px]"
                          >
                            <Stack flex={0.5}>
                              <Typography
                                className="fs-12 ff-Roboto fw-regular !capitalize"
                                color={text}
                              >
                                {t('Delivery date')}
                              </Typography>
                              <Typography
                                className="fs-14 ff-Roboto fw-medium capitalize"
                                color={text}
                                style={{ maxWidth: '225px' }}
                              >
                                {details?.deliveryDate || 'NA'}
                              </Typography>
                            </Stack>
                          </Stack>
                        )}
                        {details?.stage === 'order' && details?.quoteStatus === 'completed' && (
                          <Stack
                            direction={'row'}
                            className="px-[16px] !mb-[16px]"
                          >
                            {details?.deliveryDate && (
                              <Stack flex={0.5}>
                                <Typography
                                  className="fs-12 ff-Roboto fw-regular !capitalize"
                                  color={text}
                                >
                                  {t('Delivery date')}
                                </Typography>
                                <Typography
                                  className="fs-14 ff-Roboto fw-medium capitalize"
                                  color={text}
                                  style={{ maxWidth: '225px' }}
                                >
                                  {moment(details?.deliveryDate).format('DD-MMM-YYYY')}
                                </Typography>
                              </Stack>
                            )}
                            <Stack flex={0.5}>
                              <Typography
                                className="fs-12 ff-Roboto fw-regular"
                                color={text}
                              >
                                {t('Quote valid till')}
                              </Typography>
                              <Typography
                                className="fs-14 ff-Roboto fw-medium capitalize"
                                color={text}
                                style={{ maxWidth: '225px' }}
                              >
                                {details?.validity ? moment(details?.validity).format('DD-MMM-YYYY HH:mm:ss') : '-'}
                              </Typography>
                            </Stack>
                          </Stack>
                        )}
                        {(details?.stage === 'quote' || details?.stage === 'advisory') && (
                          <Stack
                            direction={'row'}
                            className="px-[16px] !mb-[16px]"
                          >
                            <Stack flex={0.5}>
                              <Typography
                                className="fs-12 ff-Roboto fw-regular"
                                color={text}
                              >
                                {t('Quote valid till')}
                              </Typography>
                              <Typography
                                className="fs-14 ff-Roboto fw-medium capitalize"
                                color={text}
                                style={{ maxWidth: '225px' }}
                              >
                                {details?.validity ? moment(details?.validity).format('DD-MMM-YYYY HH:mm:ss') : '-'}
                              </Typography>
                            </Stack>
                          </Stack>
                        )}
                      </Stack>
                      <Stack
                        style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                        className="!my-[10px]"
                      />
                      <Stack
                        className="p-[16px]"
                        direction={'row'}
                        alignItems={'center'}
                      >
                        {details?.attachment && (
                          <Stack flex={0.5}>
                            <DocumentViewer data={details} />
                          </Stack>
                        )}

                        <Stack flex={0.5}>
                          <Typography
                            className="fs-12 ff-Roboto fw-regular"
                            color={text}
                          >
                            {t('Remark')}
                          </Typography>
                          <Typography
                            className="fs-14 ff-Roboto fw-medium"
                            color={text}
                            style={{ marginTop: '5px', maxWidth: '225px' }}
                          >
                            {details?.remarks || '-'}
                          </Typography>
                        </Stack>
                      </Stack>
                      <Stack
                        style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                        className="!my-[10px]"
                      />

                      <Stack>
                        <TradeHistory
                          masterData={details}
                          data={details?.quoteList || []}
                        />
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>

                {details?.stage === 'request' && quotesPermission.viewAccess && (
                  <Stack
                    className="bg-white py-2"
                    direction={'row'}
                    justifyContent={'flex-end'}
                  >
                    <Button
                      sx={[
                        dialogButtonCancel,
                        {
                          color: theme.palette.primary.main,
                          textTransform: 'uppercase',
                          '&:hover': {},
                        },
                      ]}
                      variant="outlined"
                      style={{ width: '128px', height: '40px' }}
                      onClick={() => {
                        setOpenAcceptReject(true);
                        setType('accept');
                      }}
                    >
                      {t('SEND QUOTE')}
                    </Button>
                  </Stack>
                )}
                {(details?.stage === 'quote' || details?.stage === 'advisory') && (
                  <Stack
                    className="bg-white py-2"
                    direction={'row'}
                    justifyContent={'flex-end'}
                  >
                    {details?.quoteStatus === 'accepted' && orderPermission.addAccess && (
                      <Button
                        sx={[
                          dialogButtonCancel,
                          {
                            color: theme.palette.primary.main,
                            textTransform: 'uppercase',
                            '&:hover': {},
                            marginRight: '16px',
                          },
                        ]}
                        variant="outlined"
                        style={{ width: '180px', height: '40px' }}
                        onClick={() => {
                          setOpenProcessQuote(true);
                        }}
                      >
                        {t('PROCESS')}
                      </Button>
                    )}
                    {quotesPermission.editAccess && (
                      <Button
                        sx={[
                          dialogButtonCancel,
                          {
                            color: theme.palette.primary.main,
                            textTransform: 'uppercase',
                            '&:hover': {},
                          },
                        ]}
                        variant="outlined"
                        style={{ width: '180px', height: '40px' }}
                        onClick={() => {
                          setOpenAcceptReject(true);
                        }}
                      >
                        {details?.quoteStatus === 'expired' ? t('RESEND QUOTE') : t('MODIFY AND RESEND')}
                      </Button>
                    )}
                  </Stack>
                )}
              </Stack>
            )}
          </>
        ) : null}
      </Stack>
      {openAcceptReject && quotesPermission.addAccess && (
        <SendQuote
          data={details}
          modelOpen={openAcceptReject}
          onModelHandleClose={(event) => {
            if (event) {
              getDetails(trade?._id);
              init();
            }
            setOpenAcceptReject(false);
          }}
        />
      )}
      {openProcessQuote && orderPermission.addAccess && (
        <ProcessQuote
          data={details}
          modelOpen={openProcessQuote}
          onModelHandleClose={(event) => {
            if (event) {
              getDetails(trade?._id);
              init();
            }
            setOpenProcessQuote(false);
          }}
        />
      )}
    </Stack>
  );
}
